import React from 'react';

const DownloadButton = ({content, buttonTitle}) => {
  const handleDownload = () => {
    const fileContent = content;
    const fileName = 'users_list.txt';
    const jsonString = JSON.stringify(fileContent, null, 2);

    const blob = new Blob([jsonString], { type: 'text/plain' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);


    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  return (
    <button onClick={handleDownload}>
      {buttonTitle}
    </button>
  );
};

export default DownloadButton;
